import React from "react";
import { Overlay, PremiumLabel } from "../RecommendedStories/PremiumStory";

const PremiumPrice = ({ price }) => (
  <div className="flex items-center">
    <div className="lh-copy">{price}</div>
    <img
      className="t-ml1 db"
      src="/images/ic-cre8.svg"
      width="16"
      height="16"
    />
  </div>
);

const PremiumEpisodeLabel = ({
  price,
  paid,
  unlockedText,
  freeText,
  className = null
}) => (
  <PremiumLabel className={className}>
    {price > 0 ? (
      paid ? (
        unlockedText
      ) : (
        <PremiumPrice price={price} />
      )
    ) : (
      freeText
    )}
  </PremiumLabel>
);

const PremiumEpisodeOverlay = ({ premium, ...labelProps }) =>
  premium ? (
    <Overlay className="bottom-0 left-0 a-bg-gradient-2">
      <PremiumEpisodeLabel {...labelProps} className="a-premium-label white" />
    </Overlay>
  ) : null;

export { PremiumPrice, PremiumEpisodeOverlay, PremiumEpisodeLabel };
